import {
  TYPE_OPERATOR,
  TYPE_DECIMAL,
  EMPTY_DECIMAL,
  TYPE_METRIC,
  TYPE_COHORT_METRIC,
} from './constants';
import { countOpenBrackets, parseFormula } from './utils';

export const validateCustomMetric = ({ formula = '' } = {}) => {
  const tokens = parseFormula(formula);
  const openBracketCount = countOpenBrackets(tokens);
  const [last] = tokens.slice(-1);
  let error = '';
  if (!last) {
    return 'Formula is required';
  }

  if (openBracketCount) {
    error = `")" is missing`;
  } else if (last.type === TYPE_OPERATOR) {
    error = `Formula has invalid ending "${last.value}"`;
  } else if (
    tokens.some(
      ({ value, type }) => type === TYPE_DECIMAL && value === EMPTY_DECIMAL
    )
  ) {
    error = `Number field(s) can't be empty`;
  }

  return error;
};

export const validateMetrics = (
  { formula = '' } = {},
  metrics = [],
  cohortMetrics = []
) => {
  const tokens = parseFormula(formula);
  const privateMetricsSet = new Set();
  tokens
    .filter(({ type }) => [TYPE_METRIC, TYPE_COHORT_METRIC].includes(type))
    .forEach(({ value, type }) => {
      let metric = null;

      switch (type) {
        case TYPE_METRIC:
          metric = metrics.find(({ id }) => id === value);
          break;
        case TYPE_COHORT_METRIC:
          metric = cohortMetrics.find(({ id }) => id === value);
          break;
      }

      if (metric && !metric.isPublic) {
        privateMetricsSet.add(metric.name);
      }
    });

  const privateMetrics = Array.from(privateMetricsSet);

  return privateMetrics.length
    ? `Metric${privateMetrics.length > 1 ? 's' : ''}  "${privateMetrics.join(
        ', '
      )}" ${privateMetrics.length > 1 ? 'are' : 'is'} private`
    : null;
};
